import apiSetting from '@/apis/setting'

const state = {
  general: {
    logo: '',
    label_text: '',
    label_color: '',
    session_timeout: '',
    company_name: '',
    product_name: '',
    product_home: '',
    support_portal: ''
  }
}

const actions = {
  async setGeneral({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const getGeneral = await apiSetting.getGeneral()

        const {
          logo,
          label_text,
          label_color,
          session_timeout,
          company_name,
          product_name,
          product_home,
          support_portal
        } = getGeneral

        await commit('setGeneral', {
          logo: logo.value,
          label_text: label_text.value,
          label_color: label_color.value,
          session_timeout: session_timeout.value,
          company_name,
          product_name,
          product_home,
          support_portal
        })

        resolve(true)
      } catch (error) {
        reject(error)
      }
    })
  }
}

const mutations = {
  setGeneral(state, data) {
    state.general = data
  }
}

export const general = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    general: state => state.general
  }
}
